"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePathsList = exports.globAsync = exports.globSync = exports.hasMagic = void 0;
// eslint-disable-next-line no-restricted-imports
const globModule = __importStar(require("glob"));
const upath_1 = __importDefault(require("upath"));
const { hasMagic } = globModule;
exports.hasMagic = hasMagic;
/**
 * Synchronous form of `glob` which returns `upath`-normalized paths.
 */
const globSync = (pattern, opts) => {
    const results = globModule.sync(pattern, Object.assign({}, opts));
    return results.map((path) => upath_1.default.normalizeSafe(path));
};
exports.globSync = globSync;
/**
 * Asynchronous form of `glob` which returns `upath`-normalized paths.
 */
const globAsync = (pattern, opts) => __awaiter(void 0, void 0, void 0, function* () {
    const results = yield globModule.glob(pattern, Object.assign({}, opts));
    return results.map((path) => upath_1.default.normalizeSafe(path));
});
exports.globAsync = globAsync;
const parsePathsList = (paths) => {
    if (!paths) {
        return [];
    }
    return paths
        .split(',')
        .flatMap((path) => (globModule.hasMagic(path) ? (0, exports.globSync)(path, { dotRelative: true }) : [path]))
        .map((path) => (path.endsWith('/') ? path.slice(0, -1) : path));
};
exports.parsePathsList = parsePathsList;
//# sourceMappingURL=glob.js.map